import axios from "axios";

export const imageurl = "https://yblapis.ganpatigroupbharat.com/api/";
// export const baseurl = 'https://bookapi.ishivax.com/api/';
export const baseurl = 'https://yblapis.ganpatigroupbharat.com/api/';
// export const baseurl = 'http://localhost:8001/api/';

export const projectNo = 'YBL';
export const projectName = 'YBL';

export const API_URL = {
  SentOtp: 'SentOtp/SentOtp',
  VerifyOTP: 'SentOtp/VerifyOTP',

  UpdateTeamLogo:'Team/UpdateTeamLogo',

  saveSocilaMedia: 'Social/saveSocilaMedia',
  getAllSocialMedia: 'Social/getAllSocialMedia',
  deleteSocialMedia: 'Social/deleteSocialMedia',

  saveYclLogo: 'Website/saveYclLogo',
  getYclLogo: 'Website/getYclLogo',
  deleteYclLogoById: 'Website/deleteYclLogoById',

  updateprofile: 'auth/updateprofile',
  login: 'auth/adminlogin',
  getBookingDetail: 'book/getBookingDetail',
  getslotdetail: 'slot/getslotdetail',
  getDonationDetail: 'donation/getDonationDetail',
  geteventdetail: 'event/geteventdetail',
  getbannerdetail: 'banner/getbannerdetail',
  getnewsdetail: 'news/getnewsdetail',
  // saveslot: 'slot/saveslot',
  saveevent: 'event/saveevent',
  savebanner: 'banner/savebanner',
  savenews: 'news/savenews',
  getamountdetail: 'amount/getamountdetail',
  saveAmount: 'amount/saveAmount',
  getBookingDetailByLoginId: 'book/getBookingDetailByLoginId',
  deleteSlotById: 'slot/deleteSlotById',
  deleteEventById: 'event/deleteEventById',
  deleteBannerById: 'banner/deleteBannerById',
  deleteNewsById: 'news/deleteNewsById',
  deleteamountById: 'amount/deleteamountById',
  updateBookingStatus: 'book/updateBookingStatus',
  getuserdetail: 'auth/getuserdetail',
  getDonationDetailByLoginId: 'donation/getDonationDetailByLoginId',
  saveNotification: 'notification/saveNotification',
  getNotificationDetail: 'notification/getNotificationDetail',
  deleteNotificationById: 'notification/deleteNotificationById',
  sandNotificationtoall: 'notification/sandNotificationtoall',

  saveSlot: 'slot/saveSlot',
  getSponsorDetail: 'sponsor/getSponsorDetail',
  savesponsor: 'sponsor/savesponsor',
  deleteSponsorById: 'sponsor/deleteSponsorById',

  getPlayerDetail: 'player/getPlayerDetail',
  assignPlayerYblTeam: 'player/assignYblTeam',
  getPartnerDetail: 'partner/getPartnerDetail',

  getSlotBooking: 'slotBook/getSlotBooking',
  deleteSlotBooking: 'slotBook/deleteSlotBooking',

  saveBoardMember: 'boardMember/saveBoardMember',
  getBoardMemberDetail: 'boardMember/getBoardMemberDetail',
  deleteBoardMemberById: 'boardMember/deleteBoardMemberById',

  getEnquiries: '/enquiry/getEnquiries',
  deleteEnquiryById: '/enquiry/deleteEnquiryById',
  saveEnquiry: '/enquiry/saveEnquiry',
  addPlayerToPartner: 'partner/addPlayerToPartner',
  getPartnerPlayersById: 'partner/getPartnerPlayersById',
  deletePartnerPlayerId: 'partner/deletePartnerPlayerId',
  getPlayersRank: 'partner/getPlayersRank',

  AddAdminPartner: 'partner/AddAdminPartner',
  getPartners: 'partner/getPartners',
  delPartnerId: 'partner/delPartnerId',

  getMenus: 'menus/getMenus',
  getMenusByRole: 'roles/getMenusByRole',

  getTeams: 'team/getTeams',
  updateTeamSeason: 'team/updateTeamSeason',
  deleteTeam: 'team/deleteTeam',
  getPassOrderslist: 'passOrder/getPassOrderslist',

  getPlayersByTeamId: 'teamPlayers/getPlayersByTeamId',
  getAllPlayers: 'teamPlayers/getAllPlayers',
  assignYclPlayerTeam: 'teamPlayers/assignTeam',

  userregister: "auth/userregister",

  deleteaccount: "auth/deleteaccount",

  saveTournament: 'tournament/saveTournament',
  getTournaments: 'tournament/getTournaments',
  getTournamentById: 'tournament/getTournamentById',
  deleteTournament: 'tournament/deleteTournament',

  saveMatch: 'match/saveMatch',
  getAll: 'match/getAll',
  getMatchById: 'match/getMatchById',
  deleteMatch: 'match/deleteMatch',

  updateToss: 'match/update-toss',
  saveMatchInnings: 'match/saveMatchInnings',
  saveBattingScorecard: 'match/saveBattingScorecard',
  saveBowlingScorecard: 'match/saveBowlingScorecard',
  getMatchInningsByMatchId: 'match/getMatchInningsByMatchId',

  addPlayingEleven: 'match/addPlayingEleven',
  getPlayingElevenByMatch: 'match/getPlayingElevenByMatch',
  updateMatchStatus: 'match/updateMatchStatus',
  updateMatchStartStatus: 'match/updateMatchStartStatus',
  updateInningPlayers: 'match/updateInningPlayers',

  getScorecard: 'match/getScorecard',
  updateBattingScore: 'match/updateBattingScore',
  updateBowlingScore: 'match/updateBowlingScore',

  updateMatchScore: 'match/updateMatchScore',
  updateBattingPosition: 'match/updateBattingPosition',
  updateCurrentBowlingIs: 'match/updateCurrentBowlingIs',
  getBowlingData: 'match/getBowlingData',

  updateInningsStatus: 'match/updateInningsStatus',
  updateBattingPositionEndInn: 'match/updateBattingPositionEndInn',

  updateBattingPos: 'match/updateBattingPos',

  updateResult: 'match/update-result',
  saveFallOfWickets: 'match/saveFallOfWickets',
  getMatchesByTournamentId: 'tournment/getMatchesByTournamentId',
  getTeamsByType: 'teams/getTeamsByType',
  addPlayers: 'teamPlayers/addPlayers',

  saveYclSponsorCategory: 'category/save',
  getYclSponsorCategory: 'category/all',
  getYclSponsorCategoryById: 'category/getById',
  deleteYclSponsorCategory: 'category/deleteById',

  saveYclSponsor: 'yclsponsor/saveSponsor',
  getYclSponsor: 'yclsponsor/all',
  getYclSponsorById: 'yclsponsor/getYclSponsorDetailById',
  deleteYclSponsor: 'yclsponsor/deleteYclSponsor',

  saveYclBanner: 'yclBanner/saveYclBanner',
  getYclBanner: 'yclBanner/getYclBannerDetail',
  deleteYclBanner: 'yclBanner/deleteYclBannerById',

  saveYclSeason: 'ycl/seasons/save',
  getYclSeasons: 'ycl/seasons/all',
  getYclSeasonById: 'ycl/seasons/getById',
  deleteYclSeason: 'ycl/seasons/delete',

  saveYblSeason: 'ybl/seasons/save',
  getYblSeasons: 'ybl/seasons/all',
  getYblSeasonById: 'ybl/seasons/getById',
  deleteYblSeason: 'ybl/seasons/delete',

  saveYblPlayer: 'ybl/players/save',
  getYblPlayers: 'ybl/players/all',
  getYblPlayerById: 'ybl/players/getById',
  deleteYblPlayer: 'ybl/players/delete',

  saveYblTeam: 'ybl/teams/save',
  getYblTeams: 'ybl/teams/all',
  getYblTeamById: 'ybl/teams/getById',
  deleteYblTeam: 'ybl/teams/delete',

  saveYblTournament: 'ybl/tournaments/save',
  getYblTournaments: 'ybl/tournaments/all',
  getYblTournamentById: 'ybl/tournaments/getById',
  deleteYblTournament: 'ybl/tournaments/delete',

  saveYblMatch: 'ybl/matches/save',
  getYblMatches: 'ybl/matches/all',
  getYblMatchById: 'ybl/matches/getById',
  deleteYblMatch: 'ybl/matches/delete',
  updateYblMatchStatus: 'ybl/matches/updateStatus',
  getYblMatchScorecard: 'ybl/matches/scorecard',
  saveYblMatchPlayers: 'ybl/matches/players/save',
  saveYblMatchScorecard: 'ybl/matches/scorecard/save',
  adjustYblMatchPoint: 'ybl/matches/scorecard/point',
  getYblWebsiteHome: 'ybl/website/home',
}

const axiosIns = axios.create({
  baseURL: baseurl,
  headers: {
    'Content-Type': 'application/json'
  }
});
export default axiosIns;
